/* eslint-disable jsx-a11y/label-has-associated-control */
// Dependecies
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Link, useParams } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import Template from '../components/Template';
import ilustracion from '../../sass/images/ilustracion-login.svg';
import PasswordChangeInput from '../components/PasswordChangeInput';
import alert from '../../sass/images/alert/alert.svg';

// hooks
import useLogin from '../hooks/useLogin';
import useVerifyEmail from '../hooks/useVerifyEmail';
import useLanguage from '../hooks/useLanguage';

function Login({ t }) {
  const { token } = useParams();
  const { register, handleSubmit, errors, control } = useForm();
  const { submit, messageError } = useLogin({});
  const { locale } = useLanguage();
  const { messegeVerify, messageErrorVerify } = useVerifyEmail(token, locale);
  const texto = messegeVerify ? t('welcome') : t('welcome-2');

  return (
    <Template
      component="login"
      type={2}
      classNameContainer="login"
      className="container_menu login"
    >
      <div className="row ">
        <div className="col-md-6  ilus-container">
          <img className="ilustration_icon" src={ilustracion} alt={t('alt:login_ilustration')} />
        </div>
        <div className="col-md-6 container_login">
          <form onSubmit={handleSubmit(submit)}>
            <h2>
              <strong>{t('get-into')}</strong>
            </h2>
            <br />
            <p>{texto}</p>
            <div className="content_field">
              {token
                ? messageErrorVerify && (
                    <div className="error_input">
                      <p>{messageErrorVerify}</p>
                    </div>
                  )
                : ''}
              {messageError !== '' && (
                <div className="error_input">
                  <p>{messageError}</p>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col">
                <label
                  htmlFor="email"
                  className={`col-form-label ${errors.email ? 'error_label' : ''}`}
                >
                  *{t('email')}
                </label>
                <div className="custom-file">
                  <input
                    className="form-control"
                    type="email"
                    id="email"
                    name="email"
                    ref={register({ required: true, pattern: /^\S+@\S+$/i })}
                  />
                  {errors.email && (
                    <div className="error_input">
                      <p>
                        <img src={alert} alt={t('alt:notification')} />
                        {t('required')}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label
                  htmlFor="password"
                  className={`col-form-label ${errors.password ? 'error_label' : ''}`}
                >
                  *{t('password')}
                </label>
                <div className="custom-file">
                  <Controller
                    className="form-control"
                    as={<PasswordChangeInput placeholder={t('write-password')} />}
                    defaultValue=""
                    rules={{ required: true }}
                    control={control}
                    id="password"
                    name="password"
                  />
                  {errors.password && (
                    <div className="error_input">
                      <p>
                        <img src={alert} alt={t('alt:notification')} />
                        {t('required')}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row login_term">
              <label className="col">
                <Link to={`/${locale}/${t('routers:RecoverPassword')}`}>
                  <strong>{t('forgot-password')}</strong>
                </Link>
              </label>
            </div>
            <div className="row term_conditions">
              <div className="col-4" />
              <input
                type="submit"
                className="col btn btn-primary send_register"
                aling="center"
                value={t('get-into')}
              />
              <div className="col-4" />
            </div>
            <br />
            <div className="row link_register">
              <label>
                {t('not-yet-registered')}&nbsp;
                <strong>
                  <Link to={`/${locale}/${t('routers:Register')}`}>{t('sign-up-here')}</Link>
                </strong>
              </label>
            </div>
          </form>
        </div>
      </div>
    </Template>
  );
}

Login.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['login', 'routers', 'alt'])(Login);
